<template>
    <div class="modal fade" id="detailsSigningModal" role="dialog" aria-labelledby="detailsSigningModalLabel"
         data-backdrop="static" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" :class="isOverdue ? 'text-danger' : ''" id="detailsSigningModalLabel">{{$tc('signing.pageTitle', 1)}}</h5>
                    <span v-if="isOverdue" class="badge badge-danger">{{ $t('signing.overdue') }}</span>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <kendo-tabstrip>
                        <ul>
                            <li class="k-state-active">{{ $t('signing.details') }}</li>
                            <li>{{ $t('signing.history') }}</li>
                            <li>{{ $t('signing.result') }}</li>
                        </ul>
                        <div>
                            <div class="row">
                                <div class="col-md-6 form-group">
                                    <label class="font-weight-bold">{{$t('signing.headers.title')}}</label>
                                    <div>{{model.title}}</div>
                                </div>
                                <div class="col-md-12 form-group">
                                    <label class="font-weight-bold">{{$t('request_n')}}</label>
                                    <div>{{model.request}}</div>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="font-weight-bold">{{$t('signing.headers.creator')}}</label>
                                    <div>{{model.creatorName}}</div>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="font-weight-bold">{{$t('signing.headers.signatories')}}</label>
                                    <div>{{model.signatoryName}}</div>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="font-weight-bold">{{$t('signing.headers.status')}}</label>
                                    <div>{{model.statusName}}</div>
                                </div>
                                <div class="col-md-6 form-group">
                                    <label class="font-weight-bold">{{$t('signing.headers.deadline')}}</label>
                                    <div>{{ model.deadline ? $moment(model.deadline).format('DD.MM.YYYY HH:mm') : '' }}</div>
                                </div>
                                <div class="col-md-12 form-group" v-if="model.attachments">
                                    <div class="font-weight-bold">{{$t('signing.attachments')}}</div>
                                    <table class="table table-hover">
                                        <thead>
                                        <tr>

                                            <th>{{ $t('signing.filesGirdHeaders.fileName') }}</th>
                                            <th>{{ $t('signing.filesGirdHeaders.fileDescription') }}</th>
                                            <th>{{ $t('signing.filesGirdHeaders.isSigned') }}</th>
                                            <th>{{ $t('signing.filesGirdHeaders.timestampUtc') }}</th>
                                            <th>{{ $t('signing.filesGirdHeaders.signedBy') }}</th>
                                            <th>{{ $t('signing.relatedCoordination') }}</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                        <tbody>
                                            <tr v-for="(item, index) in model.attachments" :key="index">
                                                <td class="py-0 align-middle">{{ item.fileName }}</td>
                                                <td class="py-0 align-middle">{{ item.description }}</td>
                                                <td class="text-center py-0 align-middle"><span class="badge" :class="item.isSigned ? 'badge-success' : 'badge-light'">{{ item.isSigned ? $t("yes") : $t("no") }}</span></td>
                                                <td class="py-0 align-middle">{{ item.signingDate ? $moment(item.signingDate).format('DD.MM.YYYY HH:mm') : '' }}</td>
                                                <td class="py-0 align-middle">{{ item.signatoryName }}</td>
                                                <td class="py-0 align-middle">
                                                    <button
                                                        v-for="(coordination, index) in item.relatedCoordinations"
                                                        :key = index
                                                        class="btn btn-link btn-primary p-0"
                                                        @click="openCoordination(coordination)"
                                                        >{{ coordination.title }}
                                                    </button>
                                                </td>
                                                <td class="text-right py-0">
                                                    <file-crud :file="item"
                                                        :readonly="true"
                                                        :type="item.docTypeCode"
                                                        :showDescription="false"
                                                        hide-file-name
                                                    >
                                                    </file-crud>
                                                </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-if="show">
                                <history :signingId="model.id"></history>
                            </div>
                        </div>
                        <div>
                            <div v-if="show">
                                <result :signingId="model.id"></result>
                            </div>
                        </div>
                    </kendo-tabstrip>
                    <div
                        class="accordion mt-2"
                        id="relatedItems"
                        v-if="model.relatedTaskId || model.relatedCoordinationId"
                    >
						<div class="card" v-if="relatedTask">
							<div class="card-header" id="headingOne">
								<h2 class="mb-0">
									<button class="btn btn-link btn-block text-left" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
										{{ $t('signing.relatedTask') }}
									</button>
								</h2>
							</div>

							<div id="collapseOne" class="collapse" aria-labelledby="headingOne" data-parent="#relatedItems">
								<div class="card-body">
									<task-details-card :model="relatedTask" show />
								</div>
							</div>
						</div>
						<div class="card" v-if="relatedCoordination">
							<div class="card-header" id="headingTwo">
								<h2 class="mb-0">
									<button class="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
										{{ $t('signing.relatedCoordination') }}
									</button>
								</h2>
							</div>
							<div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#relatedItems">
								<div class="card-body">
									<coordination-details-card :model="relatedCoordination" show />
								</div>
							</div>
						</div>
					</div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">{{$t('buttons.close')}}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FileCrud from '../common/FileCRUD';
    import history from './history';
    import result from './result';
    import signingService from '@/services/signing.service'; // SigningController
    import coordinationsService from '@/services/coordinations.service';
    import tasksService from '@/services/tasks.service';
    import TaskDetailsCard from '@/components/tasks/details.card'
	import CoordinationDetailsCard from '@/components/coordinations/details.card'
    import { SigningStatus } from '@/models/enums';

    export default {
        components: {
            FileCrud,
            history,
            result,
            TaskDetailsCard,
            CoordinationDetailsCard,
        },
        props: {
            value: {},
            show: {
                type: Boolean,
                required: false
            }
        },
        data() {
            return {
                model: {},
                relatedTask: null,
				relatedCoordination: null
            };
        },
        computed: {
            isOverdue() {
                if (!this.model || !this.model.deadline || this.model.statusId !== SigningStatus.started) {
                    return false;
                }

                const deadline = this.$moment(this.model.deadline);
                return deadline <= this.$moment();
            }
        },
        methods: {
            hide() {
                $(this.$el).modal('hide');
            },
            onClose() {
                this.$emit('update:show', false);
                this.$emit('onClose');
            },
            loadRelatedTask() {
                this.relatedTask = null;
                if (!this.model.relatedTaskId) return;

                tasksService
					.getDetailsById(this.model.relatedTaskId)
					.then((response) => {
						this.relatedTask = response.data;
					})
					.catch((error) => {
						this.$vs.notify({
							title: this.$t('notifications.error'),
							text: this.$helpers.errorText(error),
							color: this.$helpers.errorColor(error),
							time: this.$store.getters.notificationDuration,
						});
					});
            },
            loadRelatedCoordination() {
                this.relatedCoordination = null;
                if (!this.model.relatedCoordinationId) return;

                coordinationsService
					.getDetailsById(this.model.relatedCoordinationId)
					.then((response) => {
                        this.relatedCoordination = response.data;
					})
					.catch((error) => {
						this.$vs.notify({
							title: this.$t('notifications.error'),
							text: this.$helpers.errorText(error),
							color: this.$helpers.errorColor(error),
							time: this.$store.getters.notificationDuration,
						});
					});
            },
            openCoordination(coordination) {
                let routeData = this.$router.resolve({ name: 'administration/coordinations', query: { view: coordination.id } });
                window.open(routeData.href, '_blank');
            },
        },
        mounted() {
            // add modal close listener
            $(this.$el).on('hidden.bs.modal', this.onClose);
        },
        beforeDestroy() {
            // remove listener
            $(this.$el).off('hidden.bs.modal');
        },
        watch: {
            show: function (val) {
                if (val) {
                    this.model = this.value;

                    signingService.getAttachments(this.model.id)
                    .then((result) => {
                        if (result.data && Array.isArray(result.data)) {
                            if (!this.model.attachments) this.model.attachments = [];

                            result.data.forEach(el => {
                                this.model.attachments.push(el)
                            });
                        }
                    })
                    .catch((error) => {
                        console.log(error);
                    });

                    this.loadRelatedTask();
                    this.loadRelatedCoordination();

                    $(this.$el).modal('show');
                } else {
                    $(this.$el).modal('hide');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .bmd-form-group {
        padding-top: 0px;
    }
</style>
